import { vShow as _vShow, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "lsDetail"
};
const _hoisted_2 = ["id"];
const _hoisted_3 = ["id"];
const _hoisted_4 = {
  class: "imagslist"
};
const _hoisted_5 = {
  key: 0,
  class: "swiper-container swiperImg",
  ref: "swiperImg"
};
const _hoisted_6 = {
  class: "swiper-wrapper"
};
const _hoisted_7 = {
  class: "swiper-slide"
};
const _hoisted_8 = ["src", "onClick"];
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  key: 0,
  class: "imgbox",
  id: "imgbox"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = ["value"];
const _hoisted_13 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", {
    id: "containRelics",
    style: _normalizeStyle(`${$props.showModels[0] ? `${!$props.isMobile ? 'right: -22vw' : 'right: -100vw'}` : ''}`)
  }, null, 4), [[_vShow, $data.detail.type == '3D']]), _createElementVNode("div", {
    id: `loadbar_${$data.detail.code}`,
    class: "loadbar"
  }, [_createElementVNode("span", {
    id: `bar_${$data.detail.code}`,
    style: {
      "width": "0%"
    },
    class: "bar"
  }, null, 8, _hoisted_3)], 8, _hoisted_2), $data.detail.type == '图片' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(`containRelicsImg ${$props.showModels[0] && !$props.isMobile ? 'containRelicsImgMove' : ''}`),
    style: _normalizeStyle(`${$props.showModels[0] ? `${!$props.isMobile ? 'right: 12vw' : 'right: -100vw'}` : ''}`)
  }, [_createElementVNode("div", _hoisted_4, [$data.detail.images.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detail.images, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("img", {
      src: item,
      onClick: $event => $options.showBigImg(index)
    }, null, 8, _hoisted_8)]);
  }), 256))])], 512)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: $data.detail.images[0],
    onClick: _cache[0] || (_cache[0] = $event => $options.showBigImg(_ctx.index))
  }, null, 8, _hoisted_9))]), _cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "swiper-pagination"
  }, null, -1))], 6)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", {
    class: "containRelics360",
    style: _normalizeStyle(`${$props.showModels[0] ? `${!$props.isMobile ? 'right: -22vw' : 'right: -100vw'}` : ''}`)
  }, [$data.detail.type == '360' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detail.images360, item => {
    return _openBlock(), _createElementBlock("li", null, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_11)]);
  }), 256))])])) : _createCommentVNode("", true), _cache[2] || (_cache[2] = _createElementVNode("div", {
    id: "threesixty"
  }, [_createElementVNode("div", {
    id: "spinner"
  }, [_createElementVNode("span", null, "0%")]), _createElementVNode("ol", {
    id: "threesixty_images"
  })], -1))], 4), [[_vShow, $data.detail.type == '360']]), $data.detail.type == '360' && $data.detail.images360 ? (_openBlock(), _createElementBlock("input", {
    key: 1,
    type: "hidden",
    id: "360Number",
    value: $data.detail.images360.length
  }, null, 8, _hoisted_12)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", {
    class: "containRelicsVideo",
    style: _normalizeStyle(`${$props.showModels[0] ? `${!$props.isMobile ? 'margin-right: -22vw' : 'margin-right: -100vw'}` : ''}`)
  }, [_createElementVNode("video", {
    controls: "",
    src: $data.detail.video,
    id: "sound"
  }, null, 8, _hoisted_13)], 4), [[_vShow, $data.detail.type == '视频']])]);
}